(function($, undefined) {
	'use strict';
	var popup;
	var form;
	var savesPage;
	var sliders;
	
	var submitSaveForm = function () {
		var t = $(this);
		var currForm = t.closest('.artists-com-save-form');
		
		var demoId = $('input[name="demoId"]', currForm).val();
		var count = 0;
		var total = $('.artist-demo-add-to-save-item:not(.clone)', currForm).length;
		
		popup.closeAllPopup();
		
		$('.artist-demo-add-to-save-item:not(.clone)', currForm).each(function () {
			var item = $(this);
			var saveId = $('input[name="saveId"]', item).val();
			var demosArray = $('input[name="demosArray"]', item).val().split(',');
			var isChecked = $('.artist-demo-add-to-save-item-check input', item).is(':checked');
			
			if (!isChecked && demosArray.indexOf(demoId) !== -1) {
				demosArray.splice(demosArray.indexOf(demoId), 1);
			} else if(isChecked && demosArray.indexOf(demoId) === -1) {
				demosArray.push(demoId);
			}
			
			//Remove empty array element caused by empty split
			demosArray = demosArray.filter(function (el) {
			  return el != '';
			});
			
			$('input[name="saveId"][value="'+saveId+'"]').each(function () {
				var allSaveItems = $(this).closest('.artist-demo-add-to-save-item').find('[name="demosArray"]').val(demosArray.toString());
			});
			
			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				method: 'POST',
				data: {
					id: saveId,
					field3: demosArray.toString(),
					ajax: true
				},
				success: function (response) {
					console.log('save-demo-added : ' + response);
					count++;
					
					if(count === total) {
						form.showErrorPopupAnimation('form-save-added');
					}
				}
			});
		});
	};
	
	var submitAddSave = function () {
		var t = $(this);
		var currForm = t.closest('.artists-com-save-form');
		var list = $('.artists-com-save-popup-item-list');
		
		var currTitleInput = $('.form-input[name="artist-demo-add-to-save-item-add-title"]', currForm);
		var personId = $('input[name="personId"]', currForm).val();
		
		savesPage.createNewSave(currTitleInput.val(), personId, '', function (response) {
			var newElt = $('.artist-demo-add-to-save-item.clone', currForm).clone().removeClass('clone');
			$('.form-check-value', newElt).html(currTitleInput.val());
			$('input[name="saveId"]', newElt).val(response.substring('success-'.length));
			$('input[name="demosArray"]', newElt).val('');
			
			
			list.append(newElt);
			
			currTitleInput.val('').removeClass('success error').closest('.form-input-big-ctn').removeClass('error success');
		});
	};
	
	var init = function() {
		popup = Fw.component.models().popup;
		form = Fw.component.models().form;
		savesPage = Fw.page.models().saves;

		$('body').on('click', '.artist-demo-add-to-save-item-submit', submitSaveForm);
		$('body').on('click', '.artist-demo-add-to-save-item-add-btn', submitAddSave);
		
		$('.artists-com-ctn').each(function() {
			var slider = $('.all-artists-com-slider', this);
			var prevArrow = $('.slider-btn.prev', this);
			var nextArrow = $('.slider-btn.next', this);

			slider.slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				variableWidth: true,
				swipeToSlide: true,
				dots: false,
				prevArrow,
				nextArrow,
				responsive: [
					{
						breakpoint: 480,
						settings: {
							variableWidth: false
						}
					}
				]
			});

			$(this).closest('.artists-com-ctn').slideDown();
		});
	};
	
	$(window).ready(function () {
		init();
	});

})(jQuery);

